import { Link } from 'gatsby';
import React, { FC } from 'react';
import { Nav } from 'react-bootstrap';
import * as styles from './NavItem.module.scss';

interface NavItemProps {
  path: string;
}

const NavItem: FC<NavItemProps> = ({ path, children }) => {
  return (
    <Nav.Link as={Link} to={path} className={styles.navItem}>
      {children}
    </Nav.Link>
  );
};

export default NavItem;
